// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: open-interest.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.openinterest";

export interface ParticipantOpenInterest {
}

export enum ParticipantOpenInterest_Type {
  TYPE_UNKNOWN = 0,
  CLIENT = 1,
  DII = 2,
  FII = 3,
  PRO = 4,
  TOTAL = 5,
  UNRECOGNIZED = -1,
}

export function participantOpenInterest_TypeFromJSON(object: any): ParticipantOpenInterest_Type {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return ParticipantOpenInterest_Type.TYPE_UNKNOWN;
    case 1:
    case "CLIENT":
      return ParticipantOpenInterest_Type.CLIENT;
    case 2:
    case "DII":
      return ParticipantOpenInterest_Type.DII;
    case 3:
    case "FII":
      return ParticipantOpenInterest_Type.FII;
    case 4:
    case "PRO":
      return ParticipantOpenInterest_Type.PRO;
    case 5:
    case "TOTAL":
      return ParticipantOpenInterest_Type.TOTAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ParticipantOpenInterest_Type.UNRECOGNIZED;
  }
}

export function participantOpenInterest_TypeToJSON(object: ParticipantOpenInterest_Type): string {
  switch (object) {
    case ParticipantOpenInterest_Type.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case ParticipantOpenInterest_Type.CLIENT:
      return "CLIENT";
    case ParticipantOpenInterest_Type.DII:
      return "DII";
    case ParticipantOpenInterest_Type.FII:
      return "FII";
    case ParticipantOpenInterest_Type.PRO:
      return "PRO";
    case ParticipantOpenInterest_Type.TOTAL:
      return "TOTAL";
    case ParticipantOpenInterest_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ParticipantDataList {
  list: ParticipantData[];
}

export interface ParticipantData {
  date: string;
  data: string;
}

export interface OpenInterestChangeRequest {
  security: Security | undefined;
  expiries: number[];
  fromTime: number;
  toTime: number;
}

export interface OpenInterestChangeResponse {
  security: Security | undefined;
  expiryOpenInterest: ExpiryOpenInterestProto[];
  underlyingFromPrice: number;
  underlyingToPrice: number;
}

export interface ExpiryOpenInterestProto {
  expiry: number;
  strikeOptionChainLineItem: OpenInterestStrikeItem[];
}

export interface OpenInterestStrikeItem {
  from?: OpenInterestItem | undefined;
  to?: OpenInterestItem | undefined;
  strikePrice: number;
}

export interface OpenInterestItem {
  callOi: number;
  callPrice: number;
  putOi: number;
  putPrice: number;
}

export interface ParticipantSummaryResponse {
  date: string;
  participants: ParticipantSummary[];
}

export interface ParticipantSummaryRangeResponse {
  summaries: ParticipantSummaryResponse[];
}

export interface ParticipantSummary {
  type: string;
  segments: SegmentSummary[];
}

export interface SegmentSummary {
  label: string;
  netOi?: number | undefined;
  change: number;
  sentiment: Sentiment | undefined;
  children: SegmentSummary[];
}

export interface Sentiment {
  strength: Sentiment_Strength;
  direction: Sentiment_Direction;
  label: string;
}

export enum Sentiment_Strength {
  STRENGTH_UNKNOWN = 0,
  MILD = 1,
  MEDIUM = 2,
  STRONG = 3,
  UNRECOGNIZED = -1,
}

export function sentiment_StrengthFromJSON(object: any): Sentiment_Strength {
  switch (object) {
    case 0:
    case "STRENGTH_UNKNOWN":
      return Sentiment_Strength.STRENGTH_UNKNOWN;
    case 1:
    case "MILD":
      return Sentiment_Strength.MILD;
    case 2:
    case "MEDIUM":
      return Sentiment_Strength.MEDIUM;
    case 3:
    case "STRONG":
      return Sentiment_Strength.STRONG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Sentiment_Strength.UNRECOGNIZED;
  }
}

export function sentiment_StrengthToJSON(object: Sentiment_Strength): string {
  switch (object) {
    case Sentiment_Strength.STRENGTH_UNKNOWN:
      return "STRENGTH_UNKNOWN";
    case Sentiment_Strength.MILD:
      return "MILD";
    case Sentiment_Strength.MEDIUM:
      return "MEDIUM";
    case Sentiment_Strength.STRONG:
      return "STRONG";
    case Sentiment_Strength.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Sentiment_Direction {
  DIRECTION_UNKNOWN = 0,
  BULLISH = 1,
  BEARISH = 2,
  INCONCLUSIVE = 3,
  UNRECOGNIZED = -1,
}

export function sentiment_DirectionFromJSON(object: any): Sentiment_Direction {
  switch (object) {
    case 0:
    case "DIRECTION_UNKNOWN":
      return Sentiment_Direction.DIRECTION_UNKNOWN;
    case 1:
    case "BULLISH":
      return Sentiment_Direction.BULLISH;
    case 2:
    case "BEARISH":
      return Sentiment_Direction.BEARISH;
    case 3:
    case "INCONCLUSIVE":
      return Sentiment_Direction.INCONCLUSIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Sentiment_Direction.UNRECOGNIZED;
  }
}

export function sentiment_DirectionToJSON(object: Sentiment_Direction): string {
  switch (object) {
    case Sentiment_Direction.DIRECTION_UNKNOWN:
      return "DIRECTION_UNKNOWN";
    case Sentiment_Direction.BULLISH:
      return "BULLISH";
    case Sentiment_Direction.BEARISH:
      return "BEARISH";
    case Sentiment_Direction.INCONCLUSIVE:
      return "INCONCLUSIVE";
    case Sentiment_Direction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** FII Cash Data Messages */
export interface FiiCashResponse {
  date: string;
  fiiBuy: number;
  fiiSell: number;
  fiiNet: number;
  diiBuy: number;
  diiSell: number;
  diiNet: number;
  nifty?: number | undefined;
  niftyChangePercent?: number | undefined;
}

export interface ChartDataPoint {
  date: string;
  FII: number;
  DII: number;
  Nifty?: number | undefined;
}

export interface MonthlyFiiCashData {
  month: string;
  fiiBuy: number;
  fiiSell: number;
  fiiNet: number;
  diiBuy: number;
  diiSell: number;
  diiNet: number;
  nifty?: number | undefined;
  niftyChangePercent?: number | undefined;
}

export interface MonthlyChartPoint {
  /** Format: "YYYY-MM" */
  date: string;
  FII: number;
  DII: number;
  Nifty?: number | undefined;
}

export interface FiiCashDailyResponse {
  tableData: FiiCashResponse[];
  chartData: ChartDataPoint[];
}

export interface FiiCashMonthlyResponse {
  tableData: MonthlyFiiCashData[];
  chartData: MonthlyChartPoint[];
}

function createBaseParticipantOpenInterest(): ParticipantOpenInterest {
  return {};
}

export const ParticipantOpenInterest = {
  encode(_: ParticipantOpenInterest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParticipantOpenInterest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParticipantOpenInterest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ParticipantOpenInterest {
    return {};
  },

  toJSON(_: ParticipantOpenInterest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ParticipantOpenInterest>, I>>(base?: I): ParticipantOpenInterest {
    return ParticipantOpenInterest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParticipantOpenInterest>, I>>(_: I): ParticipantOpenInterest {
    const message = createBaseParticipantOpenInterest();
    return message;
  },
};

function createBaseParticipantDataList(): ParticipantDataList {
  return { list: [] };
}

export const ParticipantDataList = {
  encode(message: ParticipantDataList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.list) {
      ParticipantData.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParticipantDataList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParticipantDataList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.list.push(ParticipantData.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParticipantDataList {
    return {
      list: globalThis.Array.isArray(object?.list) ? object.list.map((e: any) => ParticipantData.fromJSON(e)) : [],
    };
  },

  toJSON(message: ParticipantDataList): unknown {
    const obj: any = {};
    if (message.list?.length) {
      obj.list = message.list.map((e) => ParticipantData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParticipantDataList>, I>>(base?: I): ParticipantDataList {
    return ParticipantDataList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParticipantDataList>, I>>(object: I): ParticipantDataList {
    const message = createBaseParticipantDataList();
    message.list = object.list?.map((e) => ParticipantData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseParticipantData(): ParticipantData {
  return { date: "", data: "" };
}

export const ParticipantData = {
  encode(message: ParticipantData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.data !== "") {
      writer.uint32(18).string(message.data);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParticipantData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParticipantData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.data = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParticipantData {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      data: isSet(object.data) ? globalThis.String(object.data) : "",
    };
  },

  toJSON(message: ParticipantData): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.data !== "") {
      obj.data = message.data;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParticipantData>, I>>(base?: I): ParticipantData {
    return ParticipantData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParticipantData>, I>>(object: I): ParticipantData {
    const message = createBaseParticipantData();
    message.date = object.date ?? "";
    message.data = object.data ?? "";
    return message;
  },
};

function createBaseOpenInterestChangeRequest(): OpenInterestChangeRequest {
  return { security: undefined, expiries: [], fromTime: 0, toTime: 0 };
}

export const OpenInterestChangeRequest = {
  encode(message: OpenInterestChangeRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    writer.uint32(18).fork();
    for (const v of message.expiries) {
      writer.int64(v);
    }
    writer.ldelim();
    if (message.fromTime !== 0) {
      writer.uint32(24).int64(message.fromTime);
    }
    if (message.toTime !== 0) {
      writer.uint32(32).int64(message.toTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OpenInterestChangeRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenInterestChangeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag === 16) {
            message.expiries.push(longToNumber(reader.int64() as Long));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.expiries.push(longToNumber(reader.int64() as Long));
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fromTime = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.toTime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenInterestChangeRequest {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      expiries: globalThis.Array.isArray(object?.expiries) ? object.expiries.map((e: any) => globalThis.Number(e)) : [],
      fromTime: isSet(object.fromTime) ? globalThis.Number(object.fromTime) : 0,
      toTime: isSet(object.toTime) ? globalThis.Number(object.toTime) : 0,
    };
  },

  toJSON(message: OpenInterestChangeRequest): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries.map((e) => Math.round(e));
    }
    if (message.fromTime !== 0) {
      obj.fromTime = Math.round(message.fromTime);
    }
    if (message.toTime !== 0) {
      obj.toTime = Math.round(message.toTime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenInterestChangeRequest>, I>>(base?: I): OpenInterestChangeRequest {
    return OpenInterestChangeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenInterestChangeRequest>, I>>(object: I): OpenInterestChangeRequest {
    const message = createBaseOpenInterestChangeRequest();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.expiries = object.expiries?.map((e) => e) || [];
    message.fromTime = object.fromTime ?? 0;
    message.toTime = object.toTime ?? 0;
    return message;
  },
};

function createBaseOpenInterestChangeResponse(): OpenInterestChangeResponse {
  return { security: undefined, expiryOpenInterest: [], underlyingFromPrice: 0, underlyingToPrice: 0 };
}

export const OpenInterestChangeResponse = {
  encode(message: OpenInterestChangeResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.expiryOpenInterest) {
      ExpiryOpenInterestProto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.underlyingFromPrice !== 0) {
      writer.uint32(24).int32(message.underlyingFromPrice);
    }
    if (message.underlyingToPrice !== 0) {
      writer.uint32(32).int32(message.underlyingToPrice);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OpenInterestChangeResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenInterestChangeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expiryOpenInterest.push(ExpiryOpenInterestProto.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.underlyingFromPrice = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.underlyingToPrice = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenInterestChangeResponse {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      expiryOpenInterest: globalThis.Array.isArray(object?.expiryOpenInterest)
        ? object.expiryOpenInterest.map((e: any) => ExpiryOpenInterestProto.fromJSON(e))
        : [],
      underlyingFromPrice: isSet(object.underlyingFromPrice) ? globalThis.Number(object.underlyingFromPrice) : 0,
      underlyingToPrice: isSet(object.underlyingToPrice) ? globalThis.Number(object.underlyingToPrice) : 0,
    };
  },

  toJSON(message: OpenInterestChangeResponse): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.expiryOpenInterest?.length) {
      obj.expiryOpenInterest = message.expiryOpenInterest.map((e) => ExpiryOpenInterestProto.toJSON(e));
    }
    if (message.underlyingFromPrice !== 0) {
      obj.underlyingFromPrice = Math.round(message.underlyingFromPrice);
    }
    if (message.underlyingToPrice !== 0) {
      obj.underlyingToPrice = Math.round(message.underlyingToPrice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenInterestChangeResponse>, I>>(base?: I): OpenInterestChangeResponse {
    return OpenInterestChangeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenInterestChangeResponse>, I>>(object: I): OpenInterestChangeResponse {
    const message = createBaseOpenInterestChangeResponse();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.expiryOpenInterest = object.expiryOpenInterest?.map((e) => ExpiryOpenInterestProto.fromPartial(e)) || [];
    message.underlyingFromPrice = object.underlyingFromPrice ?? 0;
    message.underlyingToPrice = object.underlyingToPrice ?? 0;
    return message;
  },
};

function createBaseExpiryOpenInterestProto(): ExpiryOpenInterestProto {
  return { expiry: 0, strikeOptionChainLineItem: [] };
}

export const ExpiryOpenInterestProto = {
  encode(message: ExpiryOpenInterestProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.expiry !== 0) {
      writer.uint32(8).int64(message.expiry);
    }
    for (const v of message.strikeOptionChainLineItem) {
      OpenInterestStrikeItem.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExpiryOpenInterestProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpiryOpenInterestProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.expiry = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.strikeOptionChainLineItem.push(OpenInterestStrikeItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExpiryOpenInterestProto {
    return {
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : 0,
      strikeOptionChainLineItem: globalThis.Array.isArray(object?.strikeOptionChainLineItem)
        ? object.strikeOptionChainLineItem.map((e: any) => OpenInterestStrikeItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ExpiryOpenInterestProto): unknown {
    const obj: any = {};
    if (message.expiry !== 0) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.strikeOptionChainLineItem?.length) {
      obj.strikeOptionChainLineItem = message.strikeOptionChainLineItem.map((e) => OpenInterestStrikeItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExpiryOpenInterestProto>, I>>(base?: I): ExpiryOpenInterestProto {
    return ExpiryOpenInterestProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExpiryOpenInterestProto>, I>>(object: I): ExpiryOpenInterestProto {
    const message = createBaseExpiryOpenInterestProto();
    message.expiry = object.expiry ?? 0;
    message.strikeOptionChainLineItem =
      object.strikeOptionChainLineItem?.map((e) => OpenInterestStrikeItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOpenInterestStrikeItem(): OpenInterestStrikeItem {
  return { from: undefined, to: undefined, strikePrice: 0 };
}

export const OpenInterestStrikeItem = {
  encode(message: OpenInterestStrikeItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.from !== undefined) {
      OpenInterestItem.encode(message.from, writer.uint32(10).fork()).ldelim();
    }
    if (message.to !== undefined) {
      OpenInterestItem.encode(message.to, writer.uint32(18).fork()).ldelim();
    }
    if (message.strikePrice !== 0) {
      writer.uint32(72).int32(message.strikePrice);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OpenInterestStrikeItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenInterestStrikeItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.from = OpenInterestItem.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.to = OpenInterestItem.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.strikePrice = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenInterestStrikeItem {
    return {
      from: isSet(object.from) ? OpenInterestItem.fromJSON(object.from) : undefined,
      to: isSet(object.to) ? OpenInterestItem.fromJSON(object.to) : undefined,
      strikePrice: isSet(object.strikePrice) ? globalThis.Number(object.strikePrice) : 0,
    };
  },

  toJSON(message: OpenInterestStrikeItem): unknown {
    const obj: any = {};
    if (message.from !== undefined) {
      obj.from = OpenInterestItem.toJSON(message.from);
    }
    if (message.to !== undefined) {
      obj.to = OpenInterestItem.toJSON(message.to);
    }
    if (message.strikePrice !== 0) {
      obj.strikePrice = Math.round(message.strikePrice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenInterestStrikeItem>, I>>(base?: I): OpenInterestStrikeItem {
    return OpenInterestStrikeItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenInterestStrikeItem>, I>>(object: I): OpenInterestStrikeItem {
    const message = createBaseOpenInterestStrikeItem();
    message.from = (object.from !== undefined && object.from !== null)
      ? OpenInterestItem.fromPartial(object.from)
      : undefined;
    message.to = (object.to !== undefined && object.to !== null) ? OpenInterestItem.fromPartial(object.to) : undefined;
    message.strikePrice = object.strikePrice ?? 0;
    return message;
  },
};

function createBaseOpenInterestItem(): OpenInterestItem {
  return { callOi: 0, callPrice: 0, putOi: 0, putPrice: 0 };
}

export const OpenInterestItem = {
  encode(message: OpenInterestItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callOi !== 0) {
      writer.uint32(8).int32(message.callOi);
    }
    if (message.callPrice !== 0) {
      writer.uint32(16).int32(message.callPrice);
    }
    if (message.putOi !== 0) {
      writer.uint32(24).int32(message.putOi);
    }
    if (message.putPrice !== 0) {
      writer.uint32(32).int32(message.putPrice);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OpenInterestItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpenInterestItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.callOi = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.callPrice = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.putOi = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.putPrice = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpenInterestItem {
    return {
      callOi: isSet(object.callOi) ? globalThis.Number(object.callOi) : 0,
      callPrice: isSet(object.callPrice) ? globalThis.Number(object.callPrice) : 0,
      putOi: isSet(object.putOi) ? globalThis.Number(object.putOi) : 0,
      putPrice: isSet(object.putPrice) ? globalThis.Number(object.putPrice) : 0,
    };
  },

  toJSON(message: OpenInterestItem): unknown {
    const obj: any = {};
    if (message.callOi !== 0) {
      obj.callOi = Math.round(message.callOi);
    }
    if (message.callPrice !== 0) {
      obj.callPrice = Math.round(message.callPrice);
    }
    if (message.putOi !== 0) {
      obj.putOi = Math.round(message.putOi);
    }
    if (message.putPrice !== 0) {
      obj.putPrice = Math.round(message.putPrice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpenInterestItem>, I>>(base?: I): OpenInterestItem {
    return OpenInterestItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpenInterestItem>, I>>(object: I): OpenInterestItem {
    const message = createBaseOpenInterestItem();
    message.callOi = object.callOi ?? 0;
    message.callPrice = object.callPrice ?? 0;
    message.putOi = object.putOi ?? 0;
    message.putPrice = object.putPrice ?? 0;
    return message;
  },
};

function createBaseParticipantSummaryResponse(): ParticipantSummaryResponse {
  return { date: "", participants: [] };
}

export const ParticipantSummaryResponse = {
  encode(message: ParticipantSummaryResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    for (const v of message.participants) {
      ParticipantSummary.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParticipantSummaryResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParticipantSummaryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.participants.push(ParticipantSummary.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParticipantSummaryResponse {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      participants: globalThis.Array.isArray(object?.participants)
        ? object.participants.map((e: any) => ParticipantSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ParticipantSummaryResponse): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.participants?.length) {
      obj.participants = message.participants.map((e) => ParticipantSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParticipantSummaryResponse>, I>>(base?: I): ParticipantSummaryResponse {
    return ParticipantSummaryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParticipantSummaryResponse>, I>>(object: I): ParticipantSummaryResponse {
    const message = createBaseParticipantSummaryResponse();
    message.date = object.date ?? "";
    message.participants = object.participants?.map((e) => ParticipantSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseParticipantSummaryRangeResponse(): ParticipantSummaryRangeResponse {
  return { summaries: [] };
}

export const ParticipantSummaryRangeResponse = {
  encode(message: ParticipantSummaryRangeResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.summaries) {
      ParticipantSummaryResponse.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParticipantSummaryRangeResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParticipantSummaryRangeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.summaries.push(ParticipantSummaryResponse.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParticipantSummaryRangeResponse {
    return {
      summaries: globalThis.Array.isArray(object?.summaries)
        ? object.summaries.map((e: any) => ParticipantSummaryResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ParticipantSummaryRangeResponse): unknown {
    const obj: any = {};
    if (message.summaries?.length) {
      obj.summaries = message.summaries.map((e) => ParticipantSummaryResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParticipantSummaryRangeResponse>, I>>(base?: I): ParticipantSummaryRangeResponse {
    return ParticipantSummaryRangeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParticipantSummaryRangeResponse>, I>>(
    object: I,
  ): ParticipantSummaryRangeResponse {
    const message = createBaseParticipantSummaryRangeResponse();
    message.summaries = object.summaries?.map((e) => ParticipantSummaryResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseParticipantSummary(): ParticipantSummary {
  return { type: "", segments: [] };
}

export const ParticipantSummary = {
  encode(message: ParticipantSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    for (const v of message.segments) {
      SegmentSummary.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParticipantSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParticipantSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.segments.push(SegmentSummary.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParticipantSummary {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      segments: globalThis.Array.isArray(object?.segments)
        ? object.segments.map((e: any) => SegmentSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ParticipantSummary): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.segments?.length) {
      obj.segments = message.segments.map((e) => SegmentSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParticipantSummary>, I>>(base?: I): ParticipantSummary {
    return ParticipantSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParticipantSummary>, I>>(object: I): ParticipantSummary {
    const message = createBaseParticipantSummary();
    message.type = object.type ?? "";
    message.segments = object.segments?.map((e) => SegmentSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSegmentSummary(): SegmentSummary {
  return { label: "", netOi: undefined, change: 0, sentiment: undefined, children: [] };
}

export const SegmentSummary = {
  encode(message: SegmentSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.netOi !== undefined) {
      writer.uint32(17).double(message.netOi);
    }
    if (message.change !== 0) {
      writer.uint32(25).double(message.change);
    }
    if (message.sentiment !== undefined) {
      Sentiment.encode(message.sentiment, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.children) {
      SegmentSummary.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SegmentSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSegmentSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.label = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.netOi = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.change = reader.double();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.sentiment = Sentiment.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.children.push(SegmentSummary.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SegmentSummary {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      netOi: isSet(object.netOi) ? globalThis.Number(object.netOi) : undefined,
      change: isSet(object.change) ? globalThis.Number(object.change) : 0,
      sentiment: isSet(object.sentiment) ? Sentiment.fromJSON(object.sentiment) : undefined,
      children: globalThis.Array.isArray(object?.children)
        ? object.children.map((e: any) => SegmentSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SegmentSummary): unknown {
    const obj: any = {};
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.netOi !== undefined) {
      obj.netOi = message.netOi;
    }
    if (message.change !== 0) {
      obj.change = message.change;
    }
    if (message.sentiment !== undefined) {
      obj.sentiment = Sentiment.toJSON(message.sentiment);
    }
    if (message.children?.length) {
      obj.children = message.children.map((e) => SegmentSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SegmentSummary>, I>>(base?: I): SegmentSummary {
    return SegmentSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SegmentSummary>, I>>(object: I): SegmentSummary {
    const message = createBaseSegmentSummary();
    message.label = object.label ?? "";
    message.netOi = object.netOi ?? undefined;
    message.change = object.change ?? 0;
    message.sentiment = (object.sentiment !== undefined && object.sentiment !== null)
      ? Sentiment.fromPartial(object.sentiment)
      : undefined;
    message.children = object.children?.map((e) => SegmentSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSentiment(): Sentiment {
  return { strength: 0, direction: 0, label: "" };
}

export const Sentiment = {
  encode(message: Sentiment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.strength !== 0) {
      writer.uint32(8).int32(message.strength);
    }
    if (message.direction !== 0) {
      writer.uint32(16).int32(message.direction);
    }
    if (message.label !== "") {
      writer.uint32(26).string(message.label);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Sentiment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSentiment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.strength = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.label = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Sentiment {
    return {
      strength: isSet(object.strength) ? sentiment_StrengthFromJSON(object.strength) : 0,
      direction: isSet(object.direction) ? sentiment_DirectionFromJSON(object.direction) : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : "",
    };
  },

  toJSON(message: Sentiment): unknown {
    const obj: any = {};
    if (message.strength !== 0) {
      obj.strength = sentiment_StrengthToJSON(message.strength);
    }
    if (message.direction !== 0) {
      obj.direction = sentiment_DirectionToJSON(message.direction);
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Sentiment>, I>>(base?: I): Sentiment {
    return Sentiment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sentiment>, I>>(object: I): Sentiment {
    const message = createBaseSentiment();
    message.strength = object.strength ?? 0;
    message.direction = object.direction ?? 0;
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseFiiCashResponse(): FiiCashResponse {
  return {
    date: "",
    fiiBuy: 0,
    fiiSell: 0,
    fiiNet: 0,
    diiBuy: 0,
    diiSell: 0,
    diiNet: 0,
    nifty: undefined,
    niftyChangePercent: undefined,
  };
}

export const FiiCashResponse = {
  encode(message: FiiCashResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.fiiBuy !== 0) {
      writer.uint32(17).double(message.fiiBuy);
    }
    if (message.fiiSell !== 0) {
      writer.uint32(25).double(message.fiiSell);
    }
    if (message.fiiNet !== 0) {
      writer.uint32(33).double(message.fiiNet);
    }
    if (message.diiBuy !== 0) {
      writer.uint32(41).double(message.diiBuy);
    }
    if (message.diiSell !== 0) {
      writer.uint32(49).double(message.diiSell);
    }
    if (message.diiNet !== 0) {
      writer.uint32(57).double(message.diiNet);
    }
    if (message.nifty !== undefined) {
      writer.uint32(65).double(message.nifty);
    }
    if (message.niftyChangePercent !== undefined) {
      writer.uint32(73).double(message.niftyChangePercent);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FiiCashResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFiiCashResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.fiiBuy = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.fiiSell = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.fiiNet = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.diiBuy = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.diiSell = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.diiNet = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.nifty = reader.double();
          continue;
        case 9:
          if (tag !== 73) {
            break;
          }

          message.niftyChangePercent = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FiiCashResponse {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      fiiBuy: isSet(object.fiiBuy) ? globalThis.Number(object.fiiBuy) : 0,
      fiiSell: isSet(object.fiiSell) ? globalThis.Number(object.fiiSell) : 0,
      fiiNet: isSet(object.fiiNet) ? globalThis.Number(object.fiiNet) : 0,
      diiBuy: isSet(object.diiBuy) ? globalThis.Number(object.diiBuy) : 0,
      diiSell: isSet(object.diiSell) ? globalThis.Number(object.diiSell) : 0,
      diiNet: isSet(object.diiNet) ? globalThis.Number(object.diiNet) : 0,
      nifty: isSet(object.nifty) ? globalThis.Number(object.nifty) : undefined,
      niftyChangePercent: isSet(object.niftyChangePercent) ? globalThis.Number(object.niftyChangePercent) : undefined,
    };
  },

  toJSON(message: FiiCashResponse): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.fiiBuy !== 0) {
      obj.fiiBuy = message.fiiBuy;
    }
    if (message.fiiSell !== 0) {
      obj.fiiSell = message.fiiSell;
    }
    if (message.fiiNet !== 0) {
      obj.fiiNet = message.fiiNet;
    }
    if (message.diiBuy !== 0) {
      obj.diiBuy = message.diiBuy;
    }
    if (message.diiSell !== 0) {
      obj.diiSell = message.diiSell;
    }
    if (message.diiNet !== 0) {
      obj.diiNet = message.diiNet;
    }
    if (message.nifty !== undefined) {
      obj.nifty = message.nifty;
    }
    if (message.niftyChangePercent !== undefined) {
      obj.niftyChangePercent = message.niftyChangePercent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FiiCashResponse>, I>>(base?: I): FiiCashResponse {
    return FiiCashResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FiiCashResponse>, I>>(object: I): FiiCashResponse {
    const message = createBaseFiiCashResponse();
    message.date = object.date ?? "";
    message.fiiBuy = object.fiiBuy ?? 0;
    message.fiiSell = object.fiiSell ?? 0;
    message.fiiNet = object.fiiNet ?? 0;
    message.diiBuy = object.diiBuy ?? 0;
    message.diiSell = object.diiSell ?? 0;
    message.diiNet = object.diiNet ?? 0;
    message.nifty = object.nifty ?? undefined;
    message.niftyChangePercent = object.niftyChangePercent ?? undefined;
    return message;
  },
};

function createBaseChartDataPoint(): ChartDataPoint {
  return { date: "", FII: 0, DII: 0, Nifty: undefined };
}

export const ChartDataPoint = {
  encode(message: ChartDataPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.FII !== 0) {
      writer.uint32(17).double(message.FII);
    }
    if (message.DII !== 0) {
      writer.uint32(25).double(message.DII);
    }
    if (message.Nifty !== undefined) {
      writer.uint32(33).double(message.Nifty);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChartDataPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChartDataPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.FII = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.DII = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.Nifty = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChartDataPoint {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      FII: isSet(object.FII) ? globalThis.Number(object.FII) : 0,
      DII: isSet(object.DII) ? globalThis.Number(object.DII) : 0,
      Nifty: isSet(object.Nifty) ? globalThis.Number(object.Nifty) : undefined,
    };
  },

  toJSON(message: ChartDataPoint): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.FII !== 0) {
      obj.FII = message.FII;
    }
    if (message.DII !== 0) {
      obj.DII = message.DII;
    }
    if (message.Nifty !== undefined) {
      obj.Nifty = message.Nifty;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChartDataPoint>, I>>(base?: I): ChartDataPoint {
    return ChartDataPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChartDataPoint>, I>>(object: I): ChartDataPoint {
    const message = createBaseChartDataPoint();
    message.date = object.date ?? "";
    message.FII = object.FII ?? 0;
    message.DII = object.DII ?? 0;
    message.Nifty = object.Nifty ?? undefined;
    return message;
  },
};

function createBaseMonthlyFiiCashData(): MonthlyFiiCashData {
  return {
    month: "",
    fiiBuy: 0,
    fiiSell: 0,
    fiiNet: 0,
    diiBuy: 0,
    diiSell: 0,
    diiNet: 0,
    nifty: undefined,
    niftyChangePercent: undefined,
  };
}

export const MonthlyFiiCashData = {
  encode(message: MonthlyFiiCashData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.month !== "") {
      writer.uint32(10).string(message.month);
    }
    if (message.fiiBuy !== 0) {
      writer.uint32(17).double(message.fiiBuy);
    }
    if (message.fiiSell !== 0) {
      writer.uint32(25).double(message.fiiSell);
    }
    if (message.fiiNet !== 0) {
      writer.uint32(33).double(message.fiiNet);
    }
    if (message.diiBuy !== 0) {
      writer.uint32(41).double(message.diiBuy);
    }
    if (message.diiSell !== 0) {
      writer.uint32(49).double(message.diiSell);
    }
    if (message.diiNet !== 0) {
      writer.uint32(57).double(message.diiNet);
    }
    if (message.nifty !== undefined) {
      writer.uint32(65).double(message.nifty);
    }
    if (message.niftyChangePercent !== undefined) {
      writer.uint32(73).double(message.niftyChangePercent);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MonthlyFiiCashData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMonthlyFiiCashData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.month = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.fiiBuy = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.fiiSell = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.fiiNet = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.diiBuy = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.diiSell = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.diiNet = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.nifty = reader.double();
          continue;
        case 9:
          if (tag !== 73) {
            break;
          }

          message.niftyChangePercent = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MonthlyFiiCashData {
    return {
      month: isSet(object.month) ? globalThis.String(object.month) : "",
      fiiBuy: isSet(object.fiiBuy) ? globalThis.Number(object.fiiBuy) : 0,
      fiiSell: isSet(object.fiiSell) ? globalThis.Number(object.fiiSell) : 0,
      fiiNet: isSet(object.fiiNet) ? globalThis.Number(object.fiiNet) : 0,
      diiBuy: isSet(object.diiBuy) ? globalThis.Number(object.diiBuy) : 0,
      diiSell: isSet(object.diiSell) ? globalThis.Number(object.diiSell) : 0,
      diiNet: isSet(object.diiNet) ? globalThis.Number(object.diiNet) : 0,
      nifty: isSet(object.nifty) ? globalThis.Number(object.nifty) : undefined,
      niftyChangePercent: isSet(object.niftyChangePercent) ? globalThis.Number(object.niftyChangePercent) : undefined,
    };
  },

  toJSON(message: MonthlyFiiCashData): unknown {
    const obj: any = {};
    if (message.month !== "") {
      obj.month = message.month;
    }
    if (message.fiiBuy !== 0) {
      obj.fiiBuy = message.fiiBuy;
    }
    if (message.fiiSell !== 0) {
      obj.fiiSell = message.fiiSell;
    }
    if (message.fiiNet !== 0) {
      obj.fiiNet = message.fiiNet;
    }
    if (message.diiBuy !== 0) {
      obj.diiBuy = message.diiBuy;
    }
    if (message.diiSell !== 0) {
      obj.diiSell = message.diiSell;
    }
    if (message.diiNet !== 0) {
      obj.diiNet = message.diiNet;
    }
    if (message.nifty !== undefined) {
      obj.nifty = message.nifty;
    }
    if (message.niftyChangePercent !== undefined) {
      obj.niftyChangePercent = message.niftyChangePercent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MonthlyFiiCashData>, I>>(base?: I): MonthlyFiiCashData {
    return MonthlyFiiCashData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MonthlyFiiCashData>, I>>(object: I): MonthlyFiiCashData {
    const message = createBaseMonthlyFiiCashData();
    message.month = object.month ?? "";
    message.fiiBuy = object.fiiBuy ?? 0;
    message.fiiSell = object.fiiSell ?? 0;
    message.fiiNet = object.fiiNet ?? 0;
    message.diiBuy = object.diiBuy ?? 0;
    message.diiSell = object.diiSell ?? 0;
    message.diiNet = object.diiNet ?? 0;
    message.nifty = object.nifty ?? undefined;
    message.niftyChangePercent = object.niftyChangePercent ?? undefined;
    return message;
  },
};

function createBaseMonthlyChartPoint(): MonthlyChartPoint {
  return { date: "", FII: 0, DII: 0, Nifty: undefined };
}

export const MonthlyChartPoint = {
  encode(message: MonthlyChartPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.FII !== 0) {
      writer.uint32(17).double(message.FII);
    }
    if (message.DII !== 0) {
      writer.uint32(25).double(message.DII);
    }
    if (message.Nifty !== undefined) {
      writer.uint32(33).double(message.Nifty);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MonthlyChartPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMonthlyChartPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.FII = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.DII = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.Nifty = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MonthlyChartPoint {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      FII: isSet(object.FII) ? globalThis.Number(object.FII) : 0,
      DII: isSet(object.DII) ? globalThis.Number(object.DII) : 0,
      Nifty: isSet(object.Nifty) ? globalThis.Number(object.Nifty) : undefined,
    };
  },

  toJSON(message: MonthlyChartPoint): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.FII !== 0) {
      obj.FII = message.FII;
    }
    if (message.DII !== 0) {
      obj.DII = message.DII;
    }
    if (message.Nifty !== undefined) {
      obj.Nifty = message.Nifty;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MonthlyChartPoint>, I>>(base?: I): MonthlyChartPoint {
    return MonthlyChartPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MonthlyChartPoint>, I>>(object: I): MonthlyChartPoint {
    const message = createBaseMonthlyChartPoint();
    message.date = object.date ?? "";
    message.FII = object.FII ?? 0;
    message.DII = object.DII ?? 0;
    message.Nifty = object.Nifty ?? undefined;
    return message;
  },
};

function createBaseFiiCashDailyResponse(): FiiCashDailyResponse {
  return { tableData: [], chartData: [] };
}

export const FiiCashDailyResponse = {
  encode(message: FiiCashDailyResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tableData) {
      FiiCashResponse.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.chartData) {
      ChartDataPoint.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FiiCashDailyResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFiiCashDailyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tableData.push(FiiCashResponse.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.chartData.push(ChartDataPoint.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FiiCashDailyResponse {
    return {
      tableData: globalThis.Array.isArray(object?.tableData)
        ? object.tableData.map((e: any) => FiiCashResponse.fromJSON(e))
        : [],
      chartData: globalThis.Array.isArray(object?.chartData)
        ? object.chartData.map((e: any) => ChartDataPoint.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FiiCashDailyResponse): unknown {
    const obj: any = {};
    if (message.tableData?.length) {
      obj.tableData = message.tableData.map((e) => FiiCashResponse.toJSON(e));
    }
    if (message.chartData?.length) {
      obj.chartData = message.chartData.map((e) => ChartDataPoint.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FiiCashDailyResponse>, I>>(base?: I): FiiCashDailyResponse {
    return FiiCashDailyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FiiCashDailyResponse>, I>>(object: I): FiiCashDailyResponse {
    const message = createBaseFiiCashDailyResponse();
    message.tableData = object.tableData?.map((e) => FiiCashResponse.fromPartial(e)) || [];
    message.chartData = object.chartData?.map((e) => ChartDataPoint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFiiCashMonthlyResponse(): FiiCashMonthlyResponse {
  return { tableData: [], chartData: [] };
}

export const FiiCashMonthlyResponse = {
  encode(message: FiiCashMonthlyResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tableData) {
      MonthlyFiiCashData.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.chartData) {
      MonthlyChartPoint.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FiiCashMonthlyResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFiiCashMonthlyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tableData.push(MonthlyFiiCashData.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.chartData.push(MonthlyChartPoint.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FiiCashMonthlyResponse {
    return {
      tableData: globalThis.Array.isArray(object?.tableData)
        ? object.tableData.map((e: any) => MonthlyFiiCashData.fromJSON(e))
        : [],
      chartData: globalThis.Array.isArray(object?.chartData)
        ? object.chartData.map((e: any) => MonthlyChartPoint.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FiiCashMonthlyResponse): unknown {
    const obj: any = {};
    if (message.tableData?.length) {
      obj.tableData = message.tableData.map((e) => MonthlyFiiCashData.toJSON(e));
    }
    if (message.chartData?.length) {
      obj.chartData = message.chartData.map((e) => MonthlyChartPoint.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FiiCashMonthlyResponse>, I>>(base?: I): FiiCashMonthlyResponse {
    return FiiCashMonthlyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FiiCashMonthlyResponse>, I>>(object: I): FiiCashMonthlyResponse {
    const message = createBaseFiiCashMonthlyResponse();
    message.tableData = object.tableData?.map((e) => MonthlyFiiCashData.fromPartial(e)) || [];
    message.chartData = object.chartData?.map((e) => MonthlyChartPoint.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
